import { StandardObject } from '../../../../common/interfaces/api/CustomerReport';

export enum FireQuestionValue {
	HouseOrBuilding = StandardObject.Building,
	Roof = StandardObject.Roof,
	Meter = StandardObject.Meter,
	PowerLine = StandardObject.PowerLine,
	Pole = StandardObject.Pole,
	OverheadTransformer = StandardObject.Transformer,
	UndergroundTransformer = StandardObject.UndergroundTransformer,
	Tree = StandardObject.Tree,
}

export enum HouseBuildingQuestionValue {
	HouseOrBuildingOccupied = 'HouseOrBuildingOccupied',
}
